<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button @click="addZone">
          添加
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      selection
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :show-footer="true"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :footer-method="footerMethod"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车牌号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="feeType"
          title="费用项目"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.feeType"
            placeholder="请输入费用项目"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="150" field="handleTime" title="办理日期" />
      <vxe-table-column min-width="150" field="expireTime" title="到期日期" />
      <vxe-table-column
        min-width="150"
        field="advanceDay"
        title="提前预警天数"
      />
      <vxe-table-column min-width="150" field="gmtCreated" title="创建时间" />
      <vxe-table-column title="操作" min-width="140" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="editZone(scope.row)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelAddShow"
      :lock-scroll="false"
      width="600"
      height="500"
      title="基本信息"
    >
      <addInformation ref="addRef" @hideModel="cancel" />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditShow"
      :lock-scroll="false"
      width="600"
      height="500"
      title="基本信息"
    >
      <editInformation ref="editRef" @hideModel="cancel" />
    </vxe-modal>
  </div>
</template>
<script>
import { sequenceShipmentLineArea } from "@/api/shipment";
import addInformation from "./components/add.vue";
import editInformation from "./components/edit.vue";
import { ctmsVehiclePrescribeFee } from "@/api/vehicleService";
import { delCtmsVehiclePrescribeFee } from "@/api/vehicleService";
export default {
  name: "RouterManagement",
  components: {
    addInformation,
    editInformation
  },
  data() {
    return {
      tableExport: {
        type: "xlsx"
      },
      zoneData: [
        {
          index: "0",
          expressCode: "SF",
          expressName: "顺丰快递",
          status: true
        },
        {
          index: "1",
          expressCode: "YTO",
          expressName: "圆通快递",
          status: true
        },
        {
          index: "2",
          expressCode: "UC",
          expressName: "优速快递",
          status: true
        }
      ],
      activeNames: ["1"],
      gmtCreatedRange: "",
      gmtAuthRange: "",
      loading: false,
      modelAddShow: false,
      modelEditShow: false,
      modelPlusShow: false,
      tableData: [],
      listQuery: {
        staffType: "0", // 类型（托运人）
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      sumObject: {
        freezingAmount: 0,
        amount: 0
      },
      Pagingconf: []
    };
  },
  created() {
    this.findList();
    let shipmentUserCode = this.$route.query.partyCode;
    this.listQuery.shipmentUserCode = shipmentUserCode;
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        ctmsVehiclePrescribeFee(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
          this.loading = false;
          resolve();
        });
      });
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "upstreamCost",
              "collectionDelivery",
              "totalDriverFreight"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (columnIndex === 21) {
            return 4;
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    },
    handleChange(val) {},
    batchDelete() {
      // let codesStr="";
      // let reCodeArr=this.$refs.xTable.selection;
      // let codes = []
      // for(let i in reCodeArr) {
      //     codes.push(reCodeArr[i].code)
      //     codesStr=codesStr+","+reCodeArr[i].code;
      // }
      // request({url: `/ntocc-ctms-api/ctmsAssignOrder/generateMainOrder`, method: 'PUT',params: {codesStr: codesStr }}).then(response => {
      //     this.dispathCarsList();
      // })
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("是否删除此规定费用表？")
        .then(_ => {
          delCtmsVehiclePrescribeFee({ codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },

    plusZone(code) {
      this.modelPlusShow = true;
      this.$refs.plusRef.getInfo(code, this.listQuery.shipmentUserCode);
    },
    addZone() {
      this.modelAddShow = true;
    },
    sortUp(row) {
      sequenceShipmentLineArea({ code: row.code, type: 1 }).then(response => {
        this.$message({ message: response.msg, type: "success" });
        this.findList();
      });
    },
    sortDown(row) {
      sequenceShipmentLineArea({ code: row.code, type: 2 }).then(response => {
        this.$message({ message: response.msg, type: "success" });
        this.findList();
      });
    },
    // 编辑区域
    editZone(data) {
      this.modelEditShow = true;
      this.$refs.editRef.getInfo(data.code);
    },
    cancel() {
      this.modelAddShow = false;
      this.modelEditShow = false;
      this.modelPlusShow = false;
      this.findList();
    }
  }
};
</script>

<style>
.vxe-table .vxe-body--column:not(.col--ellipsis),
.vxe-table .vxe-footer--column:not(.col--ellipsis),
.vxe-table .vxe-header--column:not(.col--ellipsis) {
  padding: 6px 0;
}

/* .vxe-toolbar {
    padding: 0 0 10px 0;
  } */

/* .box-all{
    padding: 10px 20px;
  } */
</style>
